import { CREATE_INTERNAL_PRICE_QUOTE } from './reservationsPermissions';

export const REPORTS_MODULE = 'REPORTS_MODULE';

// export const VIEW_REPORTS = CREATE_INTERNAL_PRICE_QUOTE;
// export const DOWNLOAD_REPORTS = CREATE_INTERNAL_PRICE_QUOTE;
export const VIEW_REPORTS = 'VIEW_REPORTS';
export const DOWNLOAD_REPORTS = VIEW_REPORTS;

export const REPORT_PERMISSION_DICTIONARY = {
    'EXTRA_CHARGE_BY_USER': 'EXTRA_CHARGE_BY_USER_REPORT',
    'RESERVATION_CONTRACT_HISTORY': 'RESERVATION_CONTRACT_HISTORY_REPORT',
    'GENERAL_VEHICLE_CHANGE': 'GENERAL_VEHICLE_CHANGE_REPORT',
    'RESERVATION': 'RESERVATION_REPORT',
    'EXTRA_CHARGES': 'EXTRA_CHARGES_REPORT',
    'CUSTOMERS_BAN': 'CUSTOMERS_BAN_REPORT',
    'DEPARTURES_AND_ARRIVALS_TRANSFERS': 'DEPARTURES_AND_ARRIVALS_TRANSFERS_REPORT',
    'BALANCE_PER_CUSTOMER_IN_DETAIL': 'BALANCE_PER_CUSTOMER_IN_DETAIL_REPORT',
    'BRANCH_COURT': 'BRANCH_COURT_REPORT',
    'RETURNED_VEHICLES': 'RETURNED_VEHICLES_REPORT',
    'VEHICLE_SERVICES': 'VEHICLE_SERVICES_REPORT',
    'BONUS_HISTORY': 'BONUS_HISTORY_REPORT',
    'CONVERSION': 'CONVERSION_REPORT',
    'HISTORY_GPS': 'HISTORY_GPS_REPORT',
    'CANCELED_RESERVATIONS': 'CANCELED_RESERVATIONS_REPORT',
    'VIRTUAL_CONTRACT_REPORTS': 'VIRTUAL_CONTRACT_REPORTS_REPORT',
    'PLATE_HISTORY': 'PLATE_HISTORY_REPORT',
    'VEHICLE_BRANCHES': 'VEHICLE_BRANCHES_REPORT',
    'CONTRACT_OPENED_CLOSED': 'CONTRACT_OPENED_CLOSED_REPORT',
    'RETURNED_VEHICLES_BY_BRANCH': 'RETURNED_VEHICLES_BY_BRANCH_REPORT',
    'VEHICLE_CHANGE': 'VEHICLE_CHANGE_REPORT',
    'CONTRACT_OPENED_BY_USER': 'CONTRACT_OPENED_BY_USER_REPORT'
};